import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import CreateMasteryTestItemDraftDialogService from '../services/CreateMasteryTestItemDraftDialogService';
import CreateMasteryTestItemDraftDialog from './CreateMasteryTestItemDraftDialog';
import LoadMasteryTestService from '../services/LoadMasteryTestService';
import { toJS } from 'mobx';

class CreateMasteryTestItemDraftDialogContainer extends Component {
  static propTypes = {
    module: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    masteryTestId: PropTypes.string.isRequired,
  };

  loadMasteryTestService = new LoadMasteryTestService();
  componentWillMount() {
    CreateMasteryTestItemDraftDialogService.init();
    this.loadMasteryTestService.handleLoad(this.props.module.id, this.props.masteryTestId);
  }

  render() {
    if (CreateMasteryTestItemDraftDialogService.masteryTestItem && this.loadMasteryTestService.masteryTest) {
      return (
        <CreateMasteryTestItemDraftDialog
          masteryTestItem={{
            ...CreateMasteryTestItemDraftDialogService.masteryTestItem,
            masteryTest: { ...toJS(this.loadMasteryTestService.masteryTest), module: this.props.module },
          }}
          isOpen={CreateMasteryTestItemDraftDialogService.isOpen}
          onCancel={CreateMasteryTestItemDraftDialogService.handleClose}
          onSubmit={CreateMasteryTestItemDraftDialogService.handleSubmit}
          onChange={CreateMasteryTestItemDraftDialogService.form.setValue}
          values={CreateMasteryTestItemDraftDialogService.form.getValues()}
          errors={CreateMasteryTestItemDraftDialogService.form.errors}
          submitting={CreateMasteryTestItemDraftDialogService.submit.fetching}
          isDirty={CreateMasteryTestItemDraftDialogService.form.isDirty}
        />
      );
    }
    return null;
  }
}

export default observer(CreateMasteryTestItemDraftDialogContainer);
